export enum VerticalSize {
  Small = 100,
  Medium = 200,
  Large = 400,
}
